import {
  Center,
  HStack,
  IconButton,
  StackProps,
  Text,
  VStack,
} from "@chakra-ui/react";
import { FaPlus } from "react-icons/fa6";
import { PropsWithChildren } from "react";
import { HomeIcon } from "./icons/homeIcon";
import { ContestIcon } from "./icons/contestIcon";

export const TabType = {
  HOME: "home",
  WRITE: "write",
  CONTEST: "contest",
} as const;
export type TabType = (typeof TabType)[keyof typeof TabType];

type Props = {
  selectedTab: TabType;
  onPressTab?: (tab: TabType) => void;
} & StackProps;

export const BOTTOM_TABS_HEIGHT = "56px";

export const BottomTabs = ({
  selectedTab,
  onPressTab,
  ...stackProps
}: Props) => {
  return (
    <HStack
      w="full"
      h="calc(env(safe-area-inset-bottom) + 56px)"
      bg="backgroundPrimary"
      justifyContent="space-around"
      borderTopWidth={0.5}
      borderTopColor="borderBorderPrimary"
      {...stackProps}
    >
      <Center flex={1}>
        <IconWithName
          name="作品"
          selected={selectedTab === "home"}
          onClick={() => onPressTab?.("home")}
        >
          <HomeIcon />
        </IconWithName>
      </Center>

      <Center flex={1}>
        <IconButton
          aria-label="作成"
          bg="backgroundLinkPrimary"
          w="56px"
          h="44px"
          color="white"
          borderRadius={16}
          onClick={() => onPressTab?.("write")}
        >
          <FaPlus />
        </IconButton>
      </Center>

      <Center flex={1}>
        <IconWithName
          name="コンテスト"
          selected={selectedTab === "contest"}
          onClick={() => onPressTab?.("contest")}
        >
          <ContestIcon />
        </IconWithName>
      </Center>
    </HStack>
  );
};

const IconWithName = ({
  name,
  selected,
  children,
  ...stackProps
}: PropsWithChildren<{ name: string; selected: boolean } & StackProps>) => {
  return (
    <VStack
      cursor="pointer"
      alignItems="center"
      color={selected ? "contentPrimary" : "contentDisable"}
      px="4"
      h="100%"
      justifyContent="center"
      gap="3px"
      {...stackProps}
    >
      {children}
      <Text fontSize={10} fontWeight="bold" lineHeight={1.25}>
        {name}
      </Text>
    </VStack>
  );
};
